import { useState } from 'react';
import { connect } from 'react-redux';
import { getReportsDueCurrentMonthAndYear } from '../actions/reportTrackingAction';
import ReportServicePopup from '../components/report-tracking/ReportServicePopup';
import ReportsTable from '../components/report-tracking/ReportsTable';

import { UncontrolledTooltip } from 'reactstrap';
import ReportTrackingCalendar from '../components/report-tracking/ReportTrackingCalendar';
import { CalendarIcon, ListIcon } from '../services/SvgLibrary';
import tableStyles from '../styles/report-tracking/ReportTracking.module.scss';

const ReportTracking = props => {
  const [calendarView, setCalendarView] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [statuses, setStatuses] = useState({
    completed: true,
    received: true,
    upcoming: true,
    pastDue: true,
  });
  return (
    <>
      {calendarView && (
        <>
          <ReportTrackingCalendar
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            statuses={statuses}
            setStatuses={setStatuses}
          />
          <ReportServicePopup
            calendarView={calendarView}
            selectedDay={selectedDate}
            highlightTerms={(text) => text}
          />
        </>
      )}
      {calendarView && (
        <UncontrolledTooltip placement='left' target='tracker-tab'>
          A tracker monitors reports, or milestones, over all due dates mandated
          by a law or part of a law.
        </UncontrolledTooltip>
      )}
      <div className={`offcanvas-container`}>
        <button
          id='tracker-tab'
          className={tableStyles['display-mode-button']}
          onClick={() => {
            setCalendarView(!calendarView);
          }}>
          {calendarView ? <ListIcon /> : <CalendarIcon />}
          {` ${calendarView ? 'Tracker' : 'Calendar'} View`}
        </button>
      </div>
      {!calendarView && <ReportsTable />}
    </>
  );
};

const mapStateToProps = state => ({});
const mapDispatchToProps = {
  getReportsDueCurrentMonthAndYear,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportTracking);
